import LandIcon from "assets/svg/parcel-of-land-small.svg";
import EstateIcon from "assets/svg/estate-investment-specialist-small.svg";
import EndeksaIcon from "assets/svg/endeksa_logo-small.svg";
import ProjectRadarIcon from "assets/svg/project-radar-small.svg";
import Container from "components/grid/container";

import styles from "./styles.module.css";

const NotFoundSuggestion = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <span className={styles.title}>Gayrimenkul Çözümlerine Göz Atın</span>
        <div className={styles.suggestionBox}>
          <a href="/arsa" className={styles.box} title="Arsa Dünyası">
            <LandIcon />
            <span className={styles.text}>Arsa Dünyası</span>
          </a>
          <a href="/proje-radari" className={styles.box} title="Proje Radarı">
            <ProjectRadarIcon />
            <span className={styles.text}>Proje Radarı</span>
          </a>
          <a href="/emlak-yatirim-uzmani" className={styles.box} title="Emlak Yatırım Uzmanı">
            <EstateIcon />
            <span className={styles.text}>Emlak Yatırım Uzmanı</span>
          </a>
          <a href="https://www.endeksa.com/tr/emlak-degeri" rel="nofollow" className={styles.box} title="Endeksa">
            <EndeksaIcon />
            <span className={styles.text}>Endeksa</span>
          </a>
        </div>
        <div className={styles.emailText}>
          <span className={styles.emailBold}>info@emlakjet.com</span> adresine e-posta gönderebilir ya da{" "}
          <a href="/iletisim" className={styles.contactLink} title="İletişim">
            iletişim sayfamızdan
          </a>{" "}
          bizimle iletişime geçebilirsiniz.
        </div>
      </Container>
    </div>
  );
};

export default NotFoundSuggestion;
